import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { CircularProgress, Collapse, makeStyles } from "@material-ui/core";
import axios from "axios";
import "../styles/transferList.scss";
import format from "date-fns/format";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiPaper-root": {
      background: "#f2f2f2",
      padding: 20,
      width: 620,
      maxWidth: "none",
      position: "relative",
    },

    "& .MuiBackdrop-root": {
      background: "#00000024",
    },
  },

  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

export default function ReviewModal({
  open,
  setOpen,
  details,
  loadTransferList,
}) {
  const [suggestedRoutes, setSuggestedRoutes] = React.useState([]);
  const [showAlert, setShowAlert] = React.useState(false);
  const [overlayId, setOverlayId] = React.useState(null);
  const [status, setStatus] = React.useState(null);
  const [err, setErr] = React.useState(null);
  const classes = useStyles();

  React.useEffect(() => {
    if (open) getRouteList();
  }, [open]);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const showConfirmationOverlay = (id) => {
    setOverlayId(id);
  };

  const postReview = (action) => {
    setStatus("loading");
    const obj = {
      id: details.id,
      action_type: action,
      destination_route: overlayId.id,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/route_management/v1/route-transfer`,
        obj,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        setStatus("success");
        console.log(res);
        loadTransferList();
      })
      .catch((err) => {
        console.log(err.response);
        setStatus("failed");
        console.log("fail");
      });
  };

  const getRouteList = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/route_management/v1/route?agency=${details.field_force__reporting_manager__reporting_agency_id}`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        setSuggestedRoutes([...res.data]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.root}
      >
        <DialogTitle id="alert-dialog-title">
          {"Review transfer requests"}
        </DialogTitle>
        <Info item={details} />
        {
          <div className="routes-list-container">
            {suggestedRoutes.length === 0 ? (
              <div>No routes</div>
            ) : (
              suggestedRoutes
                .filter((i) => i.id !== details.current_route_id)
                .map((item) => (
                  <ReviewItem
                    key={item.id}
                    item={item}
                    setOverlayId={showConfirmationOverlay}
                    overlayId={overlayId}
                    outlet={details}
                    status={status}
                    onAction={postReview}
                  />
                ))
            )}
          </div>
        }
      </Dialog>
    </div>
  );
}

function ReviewItem({
  item,
  overlayId,
  setOverlayId,
  outlet,
  onAction,
  status,
}) {
  return (
    <div className="transfer-item">
      <Dialog
        open={overlayId && item.id === overlayId.id ? true : false}
        onClose={() => setOverlayId(null)}
      >
        <div className="confirmation-overlay">
          {status === "loading" && (
            <div className="loading">
              <CircularProgress style={{ color: "#e91e63" }} />
            </div>
          )}
          <div className="text">
            <h3>Assign this new route?</h3>
            {status === "success" ? (
              <p>Successfully assigned route</p>
            ) : status === "failed" ? (
              <p>Something went wrong. Pleast try again</p>
            ) : (
              <p>
                Are you sure you want to assign route{" "}
                <b style={{ color: "#E91E63" }}>
                  {overlayId && overlayId.name}
                </b>{" "}
                to{" "}
                <b style={{ color: "#3F51B5" }}>
                  {outlet && outlet.outlet__name}
                </b>
                ?
              </p>
            )}
          </div>
          <div className="btn-container">
            {!status && (
              <Button
                className="button assign"
                onClick={() => onAction("REQ_APPROVED")}
              >
                Yes
              </Button>
            )}
            <Button
              className="button outline"
              onClick={() => setOverlayId(null)}
            >
              {status === "success" || status === "failed" ? "Ok" : "No"}
            </Button>
          </div>
        </div>
      </Dialog>
      <div style={{ padding: 24, position: "relative", height: "100%" }}>
        <div className="suggested-route">
          <p>Suggested route</p>
        </div>
        <div className="info" style={{ color: "#e91e63" }}>
          <div>
            <p>Route</p>
            {item.name}
          </div>
        </div>
        <div className="info">
          <div>
            <p>Description</p>
            {item.description}
          </div>
        </div>
        <div className="info">
          <div>
            <p>Frequency</p>
            {item.frequency}
          </div>
        </div>
        <div className="info">
          <div>
            <p>Assigned MDO</p>
            {item.mdo_list.length === 0 ? "None" : item.mdo_list[0]}
          </div>
        </div>

        <div className="button-container">
          <Button
            className="button assign"
            onClick={() => {
              setOverlayId(item);
            }}
          >
            Assign
          </Button>
        </div>
      </div>
    </div>
  );
}

function Info({ item }) {
  return (
    <div className="info-container">
      <div
        className="info"
        style={{ fontFamily: "Roboto", color: "rgba(54, 43, 115, 1)" }}
      >
        <p>Merchant</p>
        {item.outlet__name}
      </div>
      <div className="info">
        <p>Bkash wallet no</p>
        {item.outlet__wallet_no}
      </div>
      <div className="info">
        <p>Route</p>
        {item.current_route__name}
      </div>
      <div className="info">
        <p>Field force</p>
        {item.field_force__name}
      </div>
      <div className="info">
        <p>Whitelisting number </p>
        {item.field_force__whitelisting_number}
      </div>
      <div className="info">
        <p>Address</p>
        {item.outlet__address}
      </div>
      <div className="info">
        <p>Reason</p>
        {item.reason}
      </div>
      <div className="info">
        <p>Request date and time</p>
        {format(new Date(item.action_date), "dd MMM yyyy, h:mm a")}
      </div>
    </div>
  );
}
